import { useEffect } from 'react';
import { useOverlayContext } from 'seagull';
export const useAiSearchErrorToast = (param)=>{
    let { hasError, clearError, message, toastTestId } = param;
    const { showErrorToast } = useOverlayContext();
    useEffect(()=>{
        if (!hasError) return;
        showErrorToast(message, toastTestId);
        clearError();
    }, [
        hasError,
        message,
        clearError,
        toastTestId
    ]);
};
